import { createSlice} from '@reduxjs/toolkit';

export const HRTrainingInfoSlice = createSlice({
    name: 'hrtraining',
    initialState:{
        openModal:false,
        imgEl:{src:"",alt:"",width:"",height:""}
    },
    reducers: {
        openImgModal(state,action) {
            state.openModal = action.payload;
        },
        setModalImg(state,action){
            state.imgEl = action.payload;
        }
    },
});
export const {openImgModal,setModalImg } = HRTrainingInfoSlice.actions;
  
 // reducer
export default HRTrainingInfoSlice.reducer;